var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createContainer } from 'unstated-next';
import { useEffect, useState } from 'react';
import UserContainer from '../../../../../reducers/authentication';
import { createSubUser, getOwnerParties } from '../../../../../api';
import { toast } from 'react-toastify';
import t from '../../../../../lib/translate';
import Users from '../../../hooks';
import { useNavigate } from "react-router-dom";
var useCreateUser = function () {
    var navigate = useNavigate();
    var admin = UserContainer.useContainer();
    var reloadUsers = Users.useContainer().reloadUsers;
    var _a = useState(''), username = _a[0], setUsername = _a[1];
    var _b = useState([]), userOwnerParties = _b[0], setUserOwnerParties = _b[1];
    var _c = useState([]), adminOwnerParties = _c[0], setAdminOwnerParties = _c[1];
    var _d = useState([]), userAccessLevels = _d[0], setUserAccessLevels = _d[1];
    var _e = useState([]), adminAccessLevels = _e[0], setAdminAccessLevels = _e[1];
    useEffect(function () {
        getOwnerParties().then(function (res) {
            setAdminOwnerParties(res.map(function (party) { return ({ value: party.key, label: party.name }); }));
        });
    }, []);
    useEffect(function () {
        var _a;
        if (admin && admin.user) {
            setAdminAccessLevels((_a = admin.user) === null || _a === void 0 ? void 0 : _a.permissions.filter(function (permission) { return !permission.startsWith('ALLOW_OWNERPARTY:'); }).map(function (permission) { return ({ value: permission, label: t(permission) }); }));
        }
    }, [admin]);
    var createUserFunc = function (e) {
        e.preventDefault();
        if (!userOwnerParties || !userAccessLevels) {
            return false;
        }
        var userToSave = {
            username: username,
            ownerParties: userOwnerParties.map(function (party) {
                var part = {
                    key: party.value,
                    name: party.label
                };
                return part;
            }),
            permissions: userAccessLevels.map(function (level) { return level.value; })
        };
        createSubUser(userToSave)
            .then(function (res) {
            reloadUsers();
            navigate('/admin/useradmin');
            toast.success(t('users.created', res.username));
        })
            .catch(function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, error.json()];
                    case 1:
                        body = _a.sent();
                        if (body.errors.length > 0) {
                            body.errors.forEach(function (e) {
                                var generalMessage = t('users.failed.to.create');
                                var specificError = e.errorMessage ? e.errorMessage : e.errorKey;
                                toast.error("".concat(generalMessage, ": ").concat(specificError));
                            });
                        }
                        else {
                            toast.error(t('users.failed.to.create'));
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return {
        userOwnerParties: userOwnerParties,
        adminOwnerParties: adminOwnerParties,
        userAccessLevels: userAccessLevels,
        adminAccessLevels: adminAccessLevels,
        setUserOwnerParties: setUserOwnerParties,
        setUserAccessLevels: setUserAccessLevels,
        setUsername: setUsername,
        createUserFunc: createUserFunc
    };
};
var CreateUsers = createContainer(useCreateUser);
export default CreateUsers;
